// extracted by mini-css-extract-plugin
export default {"deemphasizedLabel":"GroupedUserProfileList_deemphasizedLabel__ZEBz+"};